import React from "react";
import { Dropdown, Table } from "@optimizely/axiom";
import { User } from "../../../domain/User";
import { ATTRIBUTE_ROLES } from "../../../constants/constants";
import LimitByRole from "../LimitByRole/LimitByRole";
import { MoreMenu } from "../MoreMenu/MoreMenu";

import styles from "./AgentsTable.module.scss";

const AgentsTable = ({ agentList, onViewDetails }: { agentList?: User[]; onViewDetails: (agent: User) => void }) => {
    const displayRecord = (agent: User) => {
        const { email, firstName, id } = agent;
        return (
            <Table.TR
                key={id}
                className={styles["agents-table__row"]}
                data-testid="agent-table-row"
                onClick={() => onViewDetails(agent)}
            >
                {/* Virtual teammates carry a placeholder last name from provisioning, so only the first name is shown. */}
                <Table.TD>{firstName}</Table.TD>
                <Table.TD>{email}</Table.TD>
                <Table.TD>
                    {agent.created.toLocaleString("en-US", {
                        year: "numeric",
                        day: "numeric",
                        month: "short"
                    })}
                </Table.TD>
                <Table.TD>
                    <div onClick={(e) => e.stopPropagation()}>
                        <MoreMenu>
                            <Dropdown.ListItem>
                                <Dropdown.BlockLink onClick={() => onViewDetails(agent)}>
                                    <Dropdown.BlockLinkText text="View Details..." />
                                </Dropdown.BlockLink>
                            </Dropdown.ListItem>
                        </MoreMenu>
                    </div>
                </Table.TD>
            </Table.TR>
        );
    };

    return (
        <LimitByRole action={ATTRIBUTE_ROLES.USERS.READ} mode="unauthorized">
            <div className={styles["agents-table"]} data-testid="agents-table">
                {agentList && agentList.length > 0 && (
                    <div>
                        {/* eslint-disable-next-line react/style-prop-object */}
                        <Table className="push-double--bottom" density="loose" style="rule-no-bottom-border">
                            <Table.THead>
                                <Table.TR>
                                    <Table.TH sorting={{}} width="32%">
                                        Name
                                    </Table.TH>
                                    <Table.TH sorting={{}} width="40%">
                                        Email
                                    </Table.TH>
                                    <Table.TH sorting={{}} width="17%">
                                        Created
                                    </Table.TH>
                                    <Table.TH sorting={{}} width="5%"></Table.TH>
                                </Table.TR>
                            </Table.THead>
                            <Table.TBody>{agentList.map((agent) => displayRecord(agent))}</Table.TBody>
                        </Table>
                    </div>
                )}
            </div>
        </LimitByRole>
    );
};

AgentsTable.displayName = "AgentsTable";

export default AgentsTable;
